import { User } from "firebase/auth";

const whiteList = [
  "george.andalaft@gmail.com",
  "hananne8@gmail.com",
  "desrosiers.daniel@gmx.com",
  "sales@etpmetals.com",
];
export const isAuthorized = (user: User | null) => {
  if (!user) return false;
  return (
    user?.email?.includes("cloture-verre") ||
    user?.email?.includes("glass-railing") ||
    whiteList.indexOf(user?.email!) > -1
  );
};
